const cashinSLA = {
  'AR': 10,
  'EC': 6,
  'PE': 24,
  'CL': 2,
  'CO': 2,
  'MX': 2,
}

export const defaultMessageByCountry = (countryCode: string) => {
  if (cashinSLA[countryCode]) return `Tu dinero se acreditará en aproximadamente ${cashinSLA[countryCode]} horas hábiles`;
  else return 'Tu dinero se acreditará próximamente';
}
